module.exports = __webpack_public_path__ + "static/media/WunderHolz_logo.c8d46f92.jpg";